import { render } from "./EditForm.vue?vue&type=template&id=5fb18cd1&ts=true"
import script from "./EditForm.vue?vue&type=script&lang=ts"
export * from "./EditForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__